/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020-2022 (original work) Open Assessment Technologies SA ;
 */
import { writable, get } from 'svelte/store';

export const lastVisitedStepStore = writable(0);

/**
 * Reset lastVisitedStepStore to 0
 */
export function resetLastVisitedStep() {
    lastVisitedStepStore.set(0);
}

/**
 * Determines if an item should be disabled in non-linear restricted navigation mode.
 *
 * @param {Object} item - Item object from store
 * @param {Number} currentPosition - current item position
 * @param {Object} testPart - current test part
 * @returns {Boolean}
 */
export function isItemDisabled(item, currentPosition, testPart) {
    let lastVisitedStep = get(lastVisitedStepStore);

    const itemIndex = item.position - testPart.position;
    if (itemIndex > lastVisitedStep && itemIndex <= currentPosition) {
        lastVisitedStep = itemIndex;
        lastVisitedStepStore.set(lastVisitedStep);
    }

    return itemIndex > lastVisitedStep + 1;
}
